import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="pt-16 min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* 404 Number */}
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mb-8"
          >
            <h1 className="text-8xl md:text-9xl font-bold text-primary-600 mb-4">
              404
            </h1>
          </motion.div>

          {/* Error Message */}
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Page Not Found
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-lg mx-auto">
            Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered the wrong URL.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
            >
              Go Home
            </Link>
            <Link
              to="/pricing"
              className="inline-block bg-gray-700 hover:bg-gray-600 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
            >
              View Pricing
            </Link>
            <Link
              to="/contact"
              className="inline-block bg-gray-700 hover:bg-gray-600 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
            >
              Contact Us
            </Link>
          </div>

          {/* Helpful Links */}
          <div className="mt-12 pt-8 border-t border-gray-700">
            <p className="text-gray-400 mb-4">
              Looking for something specific?
            </p>
            <div className="flex flex-wrap gap-4 justify-center text-sm">
              <Link
                to="/"
                className="text-secondary-400 hover:text-secondary-300 transition-colors duration-200"
              >
                Home
              </Link>
              <span className="text-gray-600">•</span>
              <Link
                to="/pricing"
                className="text-secondary-400 hover:text-secondary-300 transition-colors duration-200"
              >
                Pricing
              </Link>
              <span className="text-gray-600">•</span>
              <Link
                to="/contact"
                className="text-secondary-400 hover:text-secondary-300 transition-colors duration-200"
              >
                Contact
              </Link>
              <span className="text-gray-600">•</span>
              <Link
                to="/contact" // Replace with documentation URL when available
                className="text-secondary-400 hover:text-secondary-300 transition-colors duration-200"
              >
                Documentation
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;